import { teamInfo } from '@/types/teamInfo';
import { myTeamRankInfo } from '@/types/myTeamRankInfo';

interface response {
    code: number;
    message: string;
    data: {
        teamRanks: Array<teamInfo>;
        myTeamRankInfo: myTeamRankInfo;
        host: string;
    }
  }
  
export function teamLeaderboard (): Promise<response> {
  return request({
    url: '/gamecard/v2/share/assistance/teamLeaderboard',
  });
}
  